export default __webpack_public_path__ + "static/media/ic-arrowLeft.5cc7f01b.svg";